// 婚姻状况
export const maritalStatuTypes = [
    { value: 'UN_MARRIED', text: '未婚' },
    { value: 'MARRIED', text: '已婚' },
    { value: 'DIVORCED', text: '离异' },
    { value: 'WIDOWED', text: '丧偶' },
];
